<script>
import {defineComponent} from 'vue'
import FormattedNumberInput from "@js/components/Input/FormattedNumberInput.vue";
import NumberFormatComponent from "@js/components/Formatter/NumberFormatComponent.vue";
import {useCalculatorStore} from "@js/store/CalculatorStore.js";

export default defineComponent({
  name: "GroutCalculator",
  components: {NumberFormatComponent, FormattedNumberInput},
  watch: {
    'calculatorStore.grout_calc.calc_data.grout_type': function () {
      const density = this.calculatorStore.grout_types[this.calculatorStore.grout_calc.calc_data.grout_type]
      if (density) {
        this.calculatorStore.grout_calc.calc_data.grout_density = density
      }
    }
  },
  setup() {
    const calculatorStore = useCalculatorStore()

    return {calculatorStore}
  }
})
</script>

<template>
  <div class="grid grid-cols-12 gap-5 md:gap-10">
    <div class="col-span-12 md:col-span-7">
      <div class="md:bg-grayBg md:rounded-lg md:p-8">
        <div>
          <p v-if="calculatorStore.grout_calc.error_message"
             class="text-red-600 font-bold mb-5">
            {{ calculatorStore.grout_calc.error_message }}
          </p>
          <div class="mb-5 md:mb-10">
            <p class="text-xl font-semibold mb-5">
              Параметры плитки
            </p>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div class="relative z-0 w-full group">
                <FormattedNumberInput name="tsvpp_length" id="tsvpp_length"
                                      v-model="calculatorStore.grout_calc.calc_data.tile_length"
                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                      placeholder=" "/>
                <label for="tsvpp_length"
                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                  Длина плитки (мм)
                </label>
              </div>
              <div class="relative z-0 w-full group">
                <FormattedNumberInput name="tsvpp_width" id="tsvpp_width"
                                      v-model="calculatorStore.grout_calc.calc_data.tile_width"
                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                      placeholder=" "/>
                <label for="tsvpp_width"
                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                  Ширина плитки (мм)
                </label>
              </div>
              <div class="relative z-0 w-full group">
                <FormattedNumberInput name="tsvpp_height" id="tsvpp_height"
                                      v-model="calculatorStore.grout_calc.calc_data.tile_thickness"
                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                      placeholder=" "/>
                <label for="tsvpp_height"
                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                  Толщина плитки (мм)
                </label>
              </div>
            </div>
          </div>
          <div class="mb-5 md:mb-10">
            <p class="text-xl font-semibold mb-5">
              Особенности нанесения
            </p>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div class="relative z-0 w-full group">
                <FormattedNumberInput name="tsvps_length" id="tsvps_length"
                                      v-model="calculatorStore.grout_calc.calc_data.facing_area"
                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                      placeholder=" "/>
                <label for="tsvps_length"
                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                  Площадь облицовки (м2)
                </label>
              </div>
              <div class="relative z-0 w-full group">
                <FormattedNumberInput name="tsvps_width" id="tsvps_width"
                                      v-model="calculatorStore.grout_calc.calc_data.seam_width"
                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                      placeholder=" "/>
                <label for="tsvps_width"
                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                  Ширина шва (мм)
                </label>
              </div>
            </div>
          </div>
          <div class="mb-5 md:mb-10">
            <p class="text-xl font-semibold mb-5">
              Затирка
            </p>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div class="relative z-0 w-full group">
                <select v-model="calculatorStore.grout_calc.calc_data.grout_type"
                        class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer">
                  <option v-for="(density, type) in calculatorStore.grout_types" :key="type"
                          :value="type">
                    {{ type }}
                  </option>
                </select>
                <label
                    class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                  Выберите тип затирки
                </label>
              </div>
              <div class="relative z-0 w-full group">
                <FormattedNumberInput name="tsvpzt_width" id="tsvpzt_width"
                                      v-model="calculatorStore.grout_calc.calc_data.grout_density"
                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                      placeholder=" "/>
                <label for="tsvpzt_width"
                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                  Плотность смеси (кг/дм3)
                </label>
              </div>
              <div class="relative z-0 w-full group">
                <FormattedNumberInput name="tsvpzt_length" id="tsvpzt_length"
                                      v-model="calculatorStore.grout_calc.calc_data.grout_package_weight"
                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                      placeholder=" "/>
                <label for="tsvpzt_length"
                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                  Масса упаковки (кг)
                </label>
              </div>
              <div class="relative z-0 w-full group">
                <FormattedNumberInput name="tsvpzt_width" id="tsvpzt_width"
                                      v-model="calculatorStore.grout_calc.calc_data.grout_package_price"
                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                      placeholder=" "/>
                <label for="tsvpzt_width"
                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                  Стоимость упаковки (₽)
                </label>
              </div>
            </div>
          </div>
        </div>
        <div>
          <button type="button" @click.prevent="calculatorStore.groutCalculate"
                  class="flex items-center justify-center w-full gap-2 leading-tight uppercase text-nowrap bg-baseColor md:hover:bg-baseColor/80 text-black focus:outline-none focus:ring-0 font-bold rounded-xl text-sm px-5 py-4 transition mt-5">
            Рассчитать
          </button>
          <div class="mt-5 pt-5 border-t border-gray-300"
               v-if="calculatorStore.grout_calc.is_calculated">
            <p class="text-xl font-semibold mb-5">
              Результат расчета:
            </p>
            <div class="grid grid-cols-2 gap-2 md:gap-5 mb-4">
              <div
                  class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                <div class="font-bold text-sm text-gray-600">
                  Расход усредненный на 1 м²
                </div>
                <div
                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                  {{ calculatorStore.grout_calc.result.avg_consumption_per_m2 }} кг
                </div>
              </div>
              <div
                  class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                <div class="font-bold text-sm text-gray-600">
                  Расход общий
                </div>
                <div
                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                  {{ calculatorStore.grout_calc.result.total_kg }}
                </div>
              </div>
              <div
                  class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                <div class="font-bold text-sm text-gray-600">
                  Расход общий (упаковок)
                </div>
                <div
                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                  {{ calculatorStore.grout_calc.result.total_packages }}
                </div>
              </div>
              <div
                  class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                <div class="font-bold text-sm text-gray-600">
                  Стоимость затирки
                </div>
                <div
                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                  {{ calculatorStore.grout_calc.result.total_cost }} ₽
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-span-12 md:col-span-5">
      <div>
        <h2 class="text-2xl font-semibold mb-6">Как рассчитать расход затирки для плитки — Инструкция к
          калькулятору</h2>
        <ol class="list-decimal list-outside ps-5 space-y-3 text-base">
          <li>Заполните параметры плитки: длину, ширину и толщину в миллиметрах.</li>
          <li>Толщина плитки необходима для определения глубины швов между плитками.</li>
          <li>Укажите площадь поверхности, подлежащей облицовке, и ширину шва (в мм).</li>
          <li>Обычно ширина межплиточного шва составляет 2–3 мм, иногда — до 5 мм.</li>
          <li>Из выпадающего списка выберите тип затирки: цементная, эпоксидная, полиуретановая или силиконовая.</li>
          <li>Задайте плотность затирочной смеси (в кг/дм³, то есть кг/л). При выборе типа затирки поле заполняется
            автоматически.
          </li>
          <li>Если нужно — отредактируйте плотность вручную, убедитесь, что это значение плотности, а не расход в кг на
            м².
          </li>
          <li>Укажите вес одной упаковки (в кг) и её стоимость (в ₽).</li>
          <li>Нажмите кнопку «Рассчитать», чтобы получить примерный расход затирки для заданных параметров плитки.</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
